import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrollPositions: { [url: string]: [number, number] } = {};

  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.split('?')[0];
        setTimeout(() => {
          if (this.scrollPositions[url]) {
            this.viewportScroller.scrollToPosition(this.scrollPositions[url]);
          } else {
            // Default scroll position
            this.viewportScroller.scrollToPosition([0, 0]);
            // Reset all scroll positions when navigating to a new page
            this.scrollPositions = {};
          }
        }, 0);
      }
    });
  }

  saveScrollPosition(url: string) {
    this.scrollPositions[url] = this.viewportScroller.getScrollPosition();
  }
}
